var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoneStepRental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4816_78270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 21.333V31.9997C14.2222 33.6758 14.2222 34.5138 14.7429 35.0345C15.2636 35.5552 16.1016 35.5552 17.7777 35.5552H30.2222C31.8983 35.5552 32.7363 35.5552 33.257 35.0345C33.7777 34.5138 33.7777 33.6758 33.7777 31.9997V21.333",
    stroke: "#707070",
    strokeWidth: 1.77778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4443 23.1112L21.4857 14.0698C22.6709 12.8846 23.2635 12.292 23.9999 12.292C24.7363 12.292 25.3289 12.8846 26.514 14.0698L35.5554 23.1112",
    stroke: "#707070",
    strokeWidth: 1.77778,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4443 31.1112C20.4443 29.4351 20.4443 28.5971 20.965 28.0764C21.4857 27.5557 22.3238 27.5557 23.9999 27.5557C25.676 27.5557 26.514 27.5557 27.0347 28.0764C27.5554 28.5971 27.5554 29.4351 27.5554 31.1112V36.4446H20.4443V31.1112Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3335 15.1108C29.3335 14.2727 29.3335 13.8537 29.5938 13.5934C29.8542 13.333 30.2732 13.333 31.1113 13.333C31.9493 13.333 32.3684 13.333 32.6287 13.5934C32.8891 13.8537 32.8891 14.2727 32.8891 15.1108V20.4441L30.3749 17.93C29.8611 17.4161 29.6041 17.1592 29.4688 16.8325C29.3335 16.5058 29.3335 16.1425 29.3335 15.4158V15.1108Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4816_78270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoneStepRental);
export default __webpack_public_path__ + "static/media/undone-step-rental.3f3c18cdc6db89b896b06e119da822c2.svg";
export { ForwardRef as ReactComponent };